// extracted by mini-css-extract-plugin
export var base = "_28-0";
export var updateBanner = "_28-1";